<template>
    <div :class="[classes]">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        size: {
            default: "normal",
            type: String
        },
    },
    computed: {
        classes() {
            const classes = [
                "border",
                "border-grey-100",
                "p-4",
                "rounded-lg",
                "shadow-lg"
            ];

            if (this.size === "big") {
                classes.push([
                    "border-2", "!rounded-3xl", "md:p-16"
                ]);
            }

            return classes;
        }
    }
};
</script>


<style lang="scss" scoped>

</style>
